import { VideoStreaming } from '../../../components/videodetails/v2/videostreaming'

document.querySelectorAll('.cmp-video-wrapper').forEach(element => new VideoStreaming(element as HTMLDivElement))
